import React from 'react';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import {CATEGORICAL_SEQUENCE, CHART_INK, CHART_FONT} from './chartTheme';

type Props = {
    data: Record<string, string | number>[];
    xKey: string;
    yKey: string;
    height?: number;
    /** When true, each bar gets the next fixed categorical color instead of
     * a single series color - use for a single categorical breakdown
     * (e.g. requests by status), never for a true multi-series comparison. */
    colorByCategory?: boolean;
};

const CategoryBarChart: React.FC<Props> = ({data, xKey, yKey, height = 240, colorByCategory}) => {
    if (!data || data.length === 0) {
        return <div className="text-muted small py-5 text-center">No data yet.</div>;
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={data} margin={{top: 8, right: 8, left: 0, bottom: 0}}>
                <CartesianGrid strokeDasharray="3 3" stroke={CHART_INK.grid} vertical={false}/>
                <XAxis
                    dataKey={xKey}
                    tick={{fill: CHART_INK.axis, fontSize: CHART_FONT.fontSize}}
                    axisLine={{stroke: CHART_INK.grid}}
                    tickLine={false}
                />
                <YAxis tick={{fill: CHART_INK.axis, fontSize: CHART_FONT.fontSize}} axisLine={false} tickLine={false} width={40}/>
                <Tooltip contentStyle={{borderRadius: 10, border: '1px solid #f3f3f9', fontSize: 12}}/>
                <Bar dataKey={yKey} radius={[4, 4, 0, 0]} maxBarSize={48} fill={CATEGORICAL_SEQUENCE[0]}>
                    {colorByCategory && data.map((_, i) => (
                        <Cell key={i} fill={CATEGORICAL_SEQUENCE[i % CATEGORICAL_SEQUENCE.length]}/>
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default CategoryBarChart;
